<template>
  <div class="media-input">
    <input type="file" class="form-control-file" accept="image" @change="onFileSelected" id="mediaInput" />
    <div class="progress mt-2" style="height: 4px;">
      <div class="progress-bar" id="progressBar" role="progressbar" style="width: 0%;" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <!-- PREVIEW IMAGES -->
    <div v-if="media" class="preview-image-container">
      <div @click="deleteMedia()" class="preview-image-delete clickable">
        <i class="fas fa-trash"></i>
      </div><!-- /.preview-image-delete -->
      <img :src="media.url" width="100px">
    </div><!-- /.preview-image-container -->
  </div><!-- /.media-input -->
</template>

<script>
  import firebase from 'firebase'
  export default {
    props: ['media'],
    data() {
      return {
        mediaPayload: null,
        imagePreview: null
      }
    },
    created() {
    },
    methods: {
      // What to do when files are selected
      onFileSelected(e) {
        /// Give us acess to this from within deeper functions
        let self = this
        // Get the image item
        let file = e.target.files[0]
        let name = file.name
        let dt = new Date()
        let yr = dt.getYear() + 1900
        let mo = dt.getMonth() + 1
        let day = dt.getDate()
        let hr = dt.getHours()
        let min = dt.getMinutes()
        // Cunstruct the path and storage reference for Firebase
        let mediaPath = 'images/' + yr + '/' + mo + '/' + day + '/' + hr + '_' + min + '_' + name
        // Set the Firebase storage reference for this media item
        let storageRef = firebase.storage().ref(mediaPath)
        // Upload the file to Firebase with task variable
        let task = storageRef.put(file)
        // Listen for state changes as media item is being uploaded
        task.on('state_changed', function progress(snapshot) {
            // Set percentage of the progress bat
            // todo - Make this progress bar smarter to take account of all media items being uploaded at the same time.
            let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100 + '%'
            document.getElementById('progressBar').style.width = percentage
          },
          function error(err) {
            // Catch errors from the upload of this media item
            console.log('errors: ' + err)
          },
          function complete() {
          // Establish the media object that we will build with this media item for the payload
          let mediaObject = {type:"image"}
          // We already have the Firebase path of the original media. Place it in the media object
          mediaObject.path = mediaPath;
          // Get the actual URL of the fullsized image
          storageRef.getDownloadURL().then(function(fullMediaUrl) {
            // Assign this URL to the media object
            mediaObject.url = fullMediaUrl
            self.imagePreview = fullMediaUrl
            self.mediaPayload = mediaObject
            document.getElementById('progressBar').style.width = 0
            self.$emit('mediaDelivery', mediaObject)
          }).catch(function(error) {console.log(error)})
        })
      },
      deleteMedia(media) {
        let newMediaObject = null
        this.$emit('mediaDelivery', newMediaObject)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/engine/uploaders/CharacterUpload.vue